
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/catalog-recommendations",
      function () {
        return require("private-next-pages/customer-studio/catalog-recommendations.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/catalog-recommendations"])
      });
    }
  